exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".applicant-payment .wrapper .payment{padding:0 130px}.apply .wrapper .step2active .row{margin-top:0}.apply .wrapper .step2active .row .half p{margin-top:10px}@media (max-width:768px){.applicant-payment .wrapper .payment{padding:0 8px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/payment/pay/pay.scss
// module id = 1140
// module chunks = 0